import "@arco-design/web-react/es/Space/style";
import _Space from "@arco-design/web-react/es/Space";
import "@arco-design/web-react/es/Button/style";
import _Button from "@arco-design/web-react/es/Button";
import "@arco-design/web-react/es/Checkbox/style";
import _Checkbox from "@arco-design/web-react/es/Checkbox";
import "@arco-design/web-react/es/Link/style";
import _Link from "@arco-design/web-react/es/Link";
import "@arco-design/web-react/es/Input/style";
import _Input from "@arco-design/web-react/es/Input";
import "@arco-design/web-react/es/Form/style";
import _Form from "@arco-design/web-react/es/Form";
import React, { useState, useEffect, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import useLocale from '@/utils/useLocale';
import locale from '../locale';
// Utils
import useStorage from '@/utils/useStorage';
import { setToken } from '@/utils/storage';
import { brandingLogo, useBranding } from '@/utils/branding';
import Logo from '@/assets/logo.svg'; // LESS

import styles from './style/register.module.less'; // import Logo from '@/assets/logoR.svg'
// API

import { ApiLogin } from '@/api';
const FormItem = _Form.Item; // 组件

const Login = () => {
  const history = useHistory();
  const t = useLocale(locale); // 该域名配置的白标品牌(未配置时为 null, 用默认 Logo/文案)

  const branding = useBranding();
  const brandingLogoUrl = brandingLogo(branding);

  const [form] = _Form.useForm();

  const formRef = useRef();
  const [loginParams, setLoginParams, removeLoginParams] = useStorage('loginParams');
  const [rememberPassword, setRememberPassword] = useState(!!loginParams);
  const userInfo = useSelector(state => state.userInfo);
  const dispatch = useDispatch();

  function afterLoginSuccess(params) {
    // 记住密码
    if (rememberPassword) {
      setLoginParams(JSON.stringify(params));
    } else {
      removeLoginParams();
    } // 记录登录状态


    localStorage.setItem('userStatus', 'login'); // 跳转首页

    window.location.href = '/'; // history.push('/')
  } // 读取 localStorage，设置初始值


  useEffect(() => {
    const rememberPassword = !!loginParams;
    setRememberPassword(rememberPassword);

    if (formRef.current && rememberPassword) {
      const parseParams = JSON.parse(loginParams);
      formRef.current.setFieldsValue(parseParams);
    }
  }, [loginParams]);
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: styles['logo']
  }, brandingLogoUrl ? /*#__PURE__*/React.createElement("img", {
    src: brandingLogoUrl,
    alt: branding?.brand_name,
    style: {
      height: 24
    }
  }) : /*#__PURE__*/React.createElement(Logo, null)), /*#__PURE__*/React.createElement("div", {
    className: styles['login-wrap']
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      width: '100%'
    }
  }, /*#__PURE__*/React.createElement("h4", {
    className: styles['title']
  }, branding?.title || t['login.form.title']), branding?.description ? /*#__PURE__*/React.createElement("p", {
    className: styles['description']
  }, branding.description) : null, /*#__PURE__*/React.createElement(_Form, {
    ref: formRef,
    form: form,
    wrapperCol: {
      span: 24
    },
    autoComplete: "off",
    onValuesChange: (v, vs) => {
      console.log(v, vs);
    },
    onSubmit: v => {
      ApiLogin(v).then(res => {
        // 业务错误(如账号被锁定 code 1530)已由响应拦截器提示, 这里只处理成功
        if (!res || !res.data || !res.data.data) {
          return;
        }

        console.log(res.data.traceid);
        setToken(res.data.data.token); // 存储用户信息

        dispatch({
          type: 'update-userInfo',
          payload: {
            userInfo: { ...userInfo,
              avatar: res.data.data.avatar,
              username: res.data.data.username,
              email: res.data.data.email
            }
          }
        }); // 处理记住密码

        afterLoginSuccess(v);
      });
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      justifyContent: 'space-between',
      marginBottom: 10
    }
  }, /*#__PURE__*/React.createElement("label", {
    className: styles['login-label']
  }, t['login.form.email'])), /*#__PURE__*/React.createElement(FormItem, {
    field: "email",
    rules: [{
      required: true,
      message: t['login.form.userName.errMsg']
    }]
  }, /*#__PURE__*/React.createElement(_Input, {
    height: 40
  })), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      justifyContent: 'space-between',
      marginBottom: 10
    }
  }, /*#__PURE__*/React.createElement("label", {
    className: styles['login-label']
  }, t['login.form.password']), /*#__PURE__*/React.createElement(_Link, {
    hoverable: false,
    href: "/forgot"
  }, t['login.form.forgetPassword'])), /*#__PURE__*/React.createElement(FormItem, {
    field: "password",
    rules: [{
      required: true,
      message: t['login.form.password.errMsg']
    }]
  }, /*#__PURE__*/React.createElement(_Input.Password, {
    height: 40
  })), /*#__PURE__*/React.createElement(FormItem, null, /*#__PURE__*/React.createElement(_Space, {
    direction: "vertical",
    style: {
      width: '100%'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      justifyContent: 'space-between',
      marginBottom: 20
    }
  }, /*#__PURE__*/React.createElement(_Checkbox, {
    checked: rememberPassword,
    onChange: setRememberPassword
  }, t['login.form.rememberPassword'])), /*#__PURE__*/React.createElement(_Button, {
    style: {
      height: 40
    },
    type: "primary",
    htmlType: "submit",
    long: true
  }, t['login.form.login'])))))));
};

export default Login;